import { find, go, sel, selEq } from 'fxjs/es';

export const getSizeFace = ({ base_product_faces, base_product_size_id, base_product_face_id }) =>
  go(
    base_product_faces,
    find(selEq('id', base_product_face_id)),
    sel('size_faces'),
    find(selEq('base_product_size_id', base_product_size_id)),
  );
